module.exports = __webpack_public_path__ + "static/media/PM73.377b70fb.JPG";